export default __webpack_public_path__ + "static/media/icn-checkbox-off-24px.01cae395.svg";